import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { DELETE_TWR_DEVICE } from '@app/constants/myDevices/twrDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestFailed, apiRequestDone } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/twrDevices'

const deleteTwrDeviceLogic = createLogic({
  type: DELETE_TWR_DEVICE,
  latest: true,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(DELETE_TWR_DEVICE))
    try {
      await Api.deleteTwrDevice(action.accessToken, action.id)
      dispatch(apiRequestDone(DELETE_TWR_DEVICE))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('DELETE_TWR_DEVICE failed without error')
      }
    }
    done()
  },
})

export default deleteTwrDeviceLogic
